import { configureStore } from "@reduxjs/toolkit";
import educationReducer from "./education";
import securityReducer from "./security";
import blogReducer from "./blog";
import rewardReducer from "./reward";
import levelReducer from "./level";
import catalogReducer from "./catalog";
import promotionReducer from "./promotion";
import pointsReducer from "./points";
import taskReducer from "./task";
import chatReducer from "./chat";

const store = configureStore({
  reducer: {
    loggedUserReducer: securityReducer,
    educationReducer: educationReducer,
    blogReducer,
    rewardReducer,
    levelReducer,
    catalogReducer,
    promotionReducer,
    pointsReducer,
    taskReducer,
    chatReducer,
  },
});

export default store;
